import { makeAutoObservable, runInAction } from "mobx";
import apiHandler from "../handlers/ApiHandler";

class DeviceTypeStore {
  deviceTypes = [];
  deviceImages = [];
  isLoading = false;
  error = null;

  constructor() {
    makeAutoObservable(this);
  }

  async fetchDeviceTypes() {
    this.isLoading = true;
    this.error = null;

    try {
      const response = await apiHandler.get("/api/device-types");
      runInAction(() => {
        this.deviceTypes = response;
      });
    } catch (error) {
      runInAction(() => {
        this.error = error.toString();
      });
      console.error("Error fetching device types:", error);
    } finally {
      this.isLoading = false;
    }
  }

  async fetchDeviceImages() {
    try {
      const response = await apiHandler.get("/api/device-types/images");
      runInAction(() => {
        this.deviceImages = response;
      });
    } catch (error) {
      console.error("Error fetching device images:", error);
    }
  }

  async createDeviceType(newDeviceType) {
    try {
      const response = await apiHandler.post(
        "/api/device-types",
        newDeviceType
      );
      runInAction(() => {
        this.deviceTypes.push(response);
      });
    } catch (error) {
      console.error("Error creating device type:", error);
    }
  }

  async updateDeviceType(id, updatedData) {
    try {
      await apiHandler.put(`/api/device-types/${id}`, updatedData);
      this.fetchDeviceTypes();
    } catch (error) {
      console.error("Error updating device type:", error);
    }
  }

  async deleteDeviceType(id) {
    try {
      await apiHandler.delete(`/api/device-types/${id}`);
      this.fetchDeviceTypes();
    } catch (error) {
      console.error("Error deleting device type:", error);
    }
  }

  async uploadDeviceImage(file) {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await apiHandler.post(
        "/api/device-types/upload",
        formData
      );
      this.fetchDeviceImages(); // Refresh images after upload
      return response.fileUrl;
    } catch (error) {
      console.error("Error uploading device image:", error);
      return null;
    }
  }

  get defaultTypeId() {
    const defaultType = this.deviceTypes.find(
      (t) => t.type_name.toLowerCase() === "default type"
    );
    return defaultType?.id ?? 1;
  }
}

const deviceTypeStore = new DeviceTypeStore();
export default deviceTypeStore;
